<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-start display-3 me-4">403</h1>
          <h4 class="pt-3">Acesso Negado!</h4>
          <p class="text-medium-emphasis">
            Seu usuário não possui permissões para acessar essa página.
          </p>
        </div>
        <div class="d-flex justify-content-end">
          <patron-button variant="outline" (click)="return()">Voltar</patron-button>
        </div>
      </div>
    </div>
  </div>
</div>
